<template>
    <div class="appdetail">
        <el-drawer :visible.sync="drawer" custom-class="detailDrawer" size="100%" :withHeader="false" :modal-append-to-body="true" :modal="false" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 0.5)">
            <!-- 标题、按钮 -->
            <div class="appdetail-title">
                <div class="appdetail-title-top clearfix">
                    <div class="app-titles">
                        <i :class="currentSelectMenuData.css" class="app-title-icon"></i>
                        <span class="app-title-main">{{dataInfo.name}}</span>
                    </div>
                    <div class="app-buttons">
                        <i class="el-icon-close appdetail-close" @click="closeBtn"></i>
                    </div>
                </div>
                <div class="appdetail-title-top clearfix">
                    <div class="app-titles app-titles1">
                        <i v-if="!!dataInfo.createuserdesc" class="el-icon-time ml5"></i>
                        <span v-if="!!dataInfo.createuserdesc" class="ml5">{{dataInfo.createuserdesc}}</span>
                        <span class="ml5">创建于</span>
                        <span v-if="!!dataInfo.createuserdesc" class="ml5" style="color: #08979c">{{$moment(dataInfo.createtime).fromNow()}}</span>
                        <i v-if="!!dataInfo.updateuserdesc" class="el-icon-time ml10"></i>
                        <span v-if="!!dataInfo.updateuserdesc" class="ml5">{{dataInfo.updateuserdesc}}</span>
                        <span class="ml5">更新于</span>
                        <span v-if="!!dataInfo.updatetime" class="ml5" style="color: #08979c">{{$moment(dataInfo.updatetime).fromNow()}}</span>
                    </div>
                    <div class="app-buttons">
                        <el-button icon="icon-save" class="btn-" type="primary" size="mini" @click="saveBtn('Update')">
                            <font>保存</font>
                        </el-button>
                        <el-button type="success" class="btn-" size="mini" @click="saveBtn('Submit')" v-show="addtitle">保存并继续</el-button>
                    </div>
                </div>
            </div>
            <div class="appdetail-content" :style="{height: 'calc(100vh - 91px)'}">
                <el-form inline-message :model="dataInfo" :rules="rules" ref="dataInfo">
                    <div class="content-accordion" id="information">
                    <el-collapse v-model="activeNames">
                        <el-collapse-item title="基本信息" name="1">
                        <el-row>
                            <el-col :span="6">
                            <el-form-item label="编号" prop="num" label-width="100px">
                                <el-input v-model="dataInfo.num" placeholder="自动生成" :disabled="edit"></el-input>
                            </el-form-item>
                            </el-col>
                            <el-col :span="12">
                            <el-form-item label="组名" prop="name" label-width="100px">
                                <el-input v-model="dataInfo.name"></el-input>
                            </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                            <el-form-item label="描述" prop="memo" label-width="100px">
                                <el-input v-model="dataInfo.memo"></el-input>
                            </el-form-item>
                            </el-col>
                        </el-row>
                        </el-collapse-item>

                        <el-collapse-item title="用户列表" name="2">
                        <div class="table-func pull-right pb10">
                            <el-button type="primary" size="mini" round @click="chooseUser">
                            <i class="icon-search"></i>
                            <font>选择</font>
                            </el-button>
                        </div>
                        <el-table :data="dataInfo.membershipList" border stripe :fit="true" highlight-current-row style="width: 100% ;" max-height="260" :default-sort="{prop:'dataInfo.membershipList', order: 'descending'}">
                            <el-table-column type="index" label="序号" width="50">
                            <template slot-scope="scope">
                                <span> {{scope.$index+1}} </span>
                            </template>
                            </el-table-column>
                            <el-table-column label="用户名" width="150" prop="useridDesc" sortable>
                            </el-table-column>
                            <el-table-column label="管理机构" prop="superviseIdsDesc" sortable>
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.superviseIdsDesc" :disabled="edit" placeholder="请选择">
                                <el-button slot="append" icon="el-icon-search" @click="adddeptbtn(scope.$index)"></el-button>
                                </el-input>
                            </template>
                            </el-table-column>
                            <el-table-column label="录入人" width="150" prop="createbyName" sortable>
                            </el-table-column>
                            <el-table-column label="录入时间" width="160" prop="createtime" sortable>
                            </el-table-column>
                            <el-table-column fixed="right" width="120" label="操作">
                            <template slot-scope="scope">
                                <el-button type="text" size="small" @click="delKey(scope.$index,scope.row)">
                                <i class="icon-trash red"></i>
                                </el-button>
                            </template>
                            </el-table-column>
                        </el-table>
                        </el-collapse-item>
                    </el-collapse>
                    </div>
                </el-form>
            </div>
        </el-drawer>
        <!--底部-->
    <vchoose ref="choose" :chooseParam="chooseParam" @tranFormData='getChoose'></vchoose>
    <usermask ref="usermask" @getSelData="getUserData" :dialogTit="dialogTit"></usermask>
    <el-dialog :modal-append-to-body="false" title="机构范围" :visible.sync="deptdialogVisible" width="30%">
      <div class="scrollbar" style="max-height: 400px;">
        <el-tree class="tree" ref="tree" :data="depetData" show-checkbox node-key="id" :default-checked-keys="resourceCheckedKey" :props="resourceProps" default-expand-all check-strictly>
        </el-tree>
      </div>
      <div slot="footer">
        <el-button type="primary" @click="determine">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>


import vchoose from './dataChoose.vue'
import usermask from './currentUserMask.vue'


export default {
  name: 'masks',
  components: {
    vchoose,
    usermask
  },
  data() {
    return {
      drawer:false,
      loading: false,
      basic_url: Config.dev_url,
      dialogTit: '用户列表',
      rules: {
        //组名
        name: [
          { required: true, message: '请输入', trigger: 'blur' },
          { validator: this.Validators.isSpecificKey, trigger: 'blur' },
        ],
        nickname: [
          { required: true, message: '请选择', trigger: 'blur' },
        ]
      },
      edit: true, //禁填
      down: true,
      up: false,
      index: '',//子表的索引
      id: '',//修改时用的id
      activeNames: ['1', '2', '3', '4'], //手风琴数量
      dialogVisible: false, //对话框
      deptdialogVisible: false, //机构对话框
      addtitle: true, //添加弹出框titile
      depetData: [], //数组，我这里是通过接口获取数据
      resourceCheckedKey: [], //通过接口获取的需要默认展示的数组 [1,3,15,18,...]
      resourceProps: {
        children: "children",
        label: "fullname"
      },
      dataInfo: {
        "id": '',
        "name": '',
        "num": '',
        "deptcode": '',
        "deptName": '',
        "createby": '',
        "createtime": '',
        "updateby": '',
        "updatedate": '',
        "del_flag": 0,
        'membershipList': []
      },
      chooseParam: {},
    };
  },
  methods: {
    //选择多条用户数据插入到行列表中
    getUserData(val) {
      console.log(val,"选中的数据")
      for (var i = 0; i < val.length; i++) {
        var membershipList = {}
        membershipList = {
          userid: val[i].id,
          useridDesc: val[i].nickname,
          username: val[i].username,
          deptName: val[i].deptName,
          deptcode: '',
          createby: '',
          createbyName: val[i].nickname,
          createtime: this.getToday(),
          updatetime: '',
          updateby: '',
          updatebyName: '',
          superviseIds: val[i].deptcode,
          superviseIdsDesc: val[i].deptName,
          // phone:val[i].phone,
          // isEditing: true,
        };
        this.dataInfo.membershipList.push(membershipList);

      }
    },
    //选择用户带回来值
    chooseUser() {
      var arr = [];
      for (var i = 0; i < this.dataInfo.membershipList.length; i++) {
        arr.push(this.dataInfo.membershipList[i].userid);
      }
      arr = arr.join(',');
      this.$refs.usermask.requestData('groups', arr);
    },
    //获取用户
    getChoose(data) {
      var selData = data.data;
      this.dataInfo.id = selData[0].id;
      this.dataInfo.categoryname = selData[0].categoryname;
      // this.getData(this.dataInfo.id);
    },
    //删除用户
    delKey(index, row) {
      if (row.id) {
        var url = Config.dev_url + '/api-flow/flow/group/delMembership/' + row.id;
        this.$confirm('确定删除此数据吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(({
          value
        }) => {
          this.$axios.delete(url, {}).then((res) => {
            if (res.data.code == 0) {
              this.$message({
                message: '删除成功',
                type: 'success'
              });
              this.dataInfo.membershipList.splice(index, 1);
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error'
              });
            }
          }).catch((err) => {
          });

        }).catch(() => {

        });
      } else {
        this.dataInfo.membershipList.splice(index, 1);
      }
    },
    //获取当前用户信息
    // getUser(opt) {
    //   var url = Config.dev_url + '/api-user/users/currentMap';
    //   this.$axios.get(url, {}).then((res) => {
    //     if (opt == 'new') {
    //       this.dataInfo.createby = res.data.id;
    //       this.dataInfo.createtime = this.getToday();
    //     } else {
    //       this.dataInfo.updateby = res.data.id;
    //       this.dataInfo.updatedate = this.getToday();
    //     }
    //   }).catch((err) => {
    //   });
    // },

    //获取当前时间
    getToday() {
      var date = new Date();
      var month = date.getMonth();
      month++;
      var str = date.getFullYear() + '-' + month + '-' + date.getDate() + ' ' + date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds();
      var rate = this.$moment(str).format("YYYY-MM-DD HH:mm:ss")
      return rate;
    },
    //添加显示弹窗
    addBtn() {
      this.$store.commit('setmenuAndDrawer',true)
      this.dataInfo = {
        "id": '',
        "name": '',
        "num": '',
        "memo": '',
        "deptcode": '',
        "deptName": '',
        "createby": '',
        "createdate": '',
        "updateby": '',
        "updatedate": '',
        "del_flag": '',
        "membershipList": []
      };
      this.drawer = true

      this.addtitle = true;
    //   this.getUser('new');
    },
    request(id) {
      var url = Config.dev_url + '/api-flow/flow/group/' + id;
      this.$axios.get(url, {
      }).then((res) => {
        this.dataInfo = res.data;
      }).catch((wrong) => { })
    },
    //这是查看
    view(item) {
      this.$store.commit('setmenuAndDrawer',true)
      this.drawer = true
      this.getupdateuserdesc()
      this.getcreateuserdesc()
      this.addtitle = false;

      this.dept = true;
      this.request(item.id);
    //   this.getUser('');
    },
    //提交保存
    saveBtn(parameter) {
      // var _this = this;
      var url = Config.dev_url + '/api-flow/flow/group/saveOrUpdate';
      this.$refs.dataInfo.validate((valid) => {
        if (valid) {
          this.$axios.post(url, this.dataInfo).then((res) => {
            if (res.data.code == 0) {
              this.$message({
                message: '保存成功',
                type: 'success',
              });
              if(parameter == 'Submit'){
                this.dataInfo = {
                    "id": '',
                    "name": '',
                    "num": '',
                    "memo": '',
                    "deptcode": '',
                    "deptName": '',
                    "createby": '',
                    "createdate": '',
                    "updateby": '',
                    "updatedate": '',
                    "del_flag": '',
                    "membershipList": []
                };
              }
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error',
              });
            }
          }).catch((err) => {
          });
        } else {
          return false;
        }
      });
    },
    //确定
    determine() {
      var index = this.index;
      var permissionIds = [];
      var deptIds = [];
      var deptnames = [];
      this.dataInfo.membershipList[index].superviseIds = '';
      this.dataInfo.membershipList[index].superviseIdsDesc = "";
      var permission = this.$refs.tree.getCheckedNodes(); // 获取当前的选中的数据{对象}
      for (var i = 0; i < permission.length; i++) {
        deptIds.push(permission[i].code);
        deptnames.push(permission[i].fullname);
      }
      deptIds = deptIds.join(',');
      deptnames = deptnames.join(',');
      this.dataInfo.membershipList[index].superviseIds = deptIds;
      this.dataInfo.membershipList[index].superviseIdsDesc = deptnames;
      this.deptdialogVisible = false;
    },
    //取消
    cancel() {
      this.deptdialogVisible = false;
      this.$emit('request');
    },
    adddeptbtn(index) {
      this.index = index;
      this.depet();
    },
    depet() {
      var arr = [];
      var url = Config.dev_url + '/api-user/depts/treeMap';
      this.$axios.get(url, {}).then((res) => {
        this.depetData = res.data;
        if (!!this.dataInfo.id) {
          var membershipList = this.dataInfo.membershipList;
          if (!!membershipList[this.index].superviseDepts) {
            for (var m = 0; m < membershipList[this.index].superviseDepts.length; m++) {
              arr.push(membershipList[this.index].superviseDepts[m].id);
            }
          }

          this.$nextTick(function () {
            this.$refs.tree.setCheckedKeys(arr)
          })
          this.deptdialogVisible = true;
        } else {
          this.$nextTick(function () {
            this.$refs.tree.setCheckedKeys([]);
          })
          this.deptdialogVisible = true;
        }
      }).catch((err) => {
      });
    },
    //关闭抽屉按钮点击
    closeBtn(){
        this.drawer = false
        this.$emit("requestData")
    },
    //获取创建人描述
    getcreateuserdesc() {
        if (!!this.dataInfo.createuser) {
            var url = Config.dev_url + '/api-user/users/' + this.dataInfo.createuser
            this.$axios.get(url).then((res) => {
                this.$set(this.dataInfo, 'createuserdesc', res.data.nickname)
            }).catch((err) => {
            });
        }
    },
    //获取修改人描述
    getupdateuserdesc() {
        if (!!this.dataInfo.updateuser) {
            var url = Config.dev_url + '/api-user/users/' + this.dataInfo.updateuser
            this.$axios.get(url).then((res) => {
                this.$set(this.dataInfo, 'updateuserdesc', res.data.nickname)
            }).catch((err) => {
            });
        }
    },
    //计算抽屉大小
    initDetailDrawer(){
        if((document.documentElement.clientWidth * 0.7) < 900){
            document.getElementsByClassName("detailDrawer")[0].parentNode.parentNode.style.left = "calc(100% - 900px)"
        }else{
            document.getElementsByClassName("detailDrawer")[0].parentNode.parentNode.style.left = "30%"
        }
    },
  },
  mouted() {
    this.depet();
    this.initDetailDrawer()  //初始化计算详情抽屉高度
    //窗口大小发生变化时，重新计算详情抽屉高度
    window.onresize = ()=> {
        if(document.getElementsByClassName("detailDrawer").length > 0){
            this.initDetailDrawer()
        }
    }
  },
  computed:{
      //当前左侧菜单选中的信息
      currentSelectMenuData(){
          return this.$store.state.currentSelectMenuData
      },
      //左侧菜单以及应用详情抽屉显示状态
      menuAndDrawer(){
          return this.$store.state.menuAndDrawer
      },
      //当前登录人信息
      currentuser() {
          return this.$store.state.currentuser
      },
  },
  watch:{
      //左侧菜单点击关闭抽屉
      menuAndDrawer(val){
          this.drawer = val
      },
  },
}
</script>

<style scoped>
</style>
